module.exports = __webpack_public_path__ + "static/media/home-composition.9ccbc798.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home-composition.jpg
// module id = 1263
// module chunks = 37